import React, { useState } from "react";
import { WorkFlowListColumns } from "../../Api/WorkFlowListColumns";
import List from "../../../../components/Listings/List";
import DropDownMenu from "components/DropDownMenu/DropDownMenu";
import { workFlowMenuList } from "shared/menus";
import { getImageView, completeWorkFlowService } from "services/claims.service";
import Loader from "shared/loader";
export default function WorkFlowComponent(props) {
  const { card } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [reRender, setReRender] = useState(false);
  const [loader, setLoader] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const handleViewAction = (event, value, tableMeta) => {
    window.open(
      `/#/app/workflow/view/${tableMeta.rowData[0]}/${tableMeta.rowData[3]}`,
      "_blank",
    );
  };

  // const tableOptions = {
  //   onRowClick: (rowData, rowMeta) => {
  //     window.open(`/#/app/workflow/view/${rowData[0]}/${rowData[3]}`, "_blank");
  //   },
  // };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuAction = (selectedMenu) => {
    switch (selectedMenu.key) {
      case "viewImage":
        setLoader(true);
        getImageView(selectedRow.rowData[3])
          .then((data) => {
            let buffer = data.data;
            setLoader(false);
            handleClose();
            if (selectedRow.rowData[5] === "IMAGE") {
              let blob = new Blob([buffer], { type: "image/jpeg" });
              let fileURL = window.URL.createObjectURL(blob);
              window.open(fileURL);
            } else {
              let blob = new Blob([buffer], { type: "application/pdf" });
              let fileURL = window.URL.createObjectURL(blob);
              window.open(fileURL);
            }
          })
          .catch(() => {
            setLoader(false);
          });
        break;
      case "complete":
        setAnchorEl(null);
        setLoader(true);
        completeWorkFlowService(selectedRow.rowData[6])
          .then((data) => {
            if (data.data.statusCode === 200) {
              setLoader(false);
              setReRender(!reRender);
            }
          })
          .catch(() => {
            setLoader(false);
          });
        break;
      case "reClassify":
        // setAnchorEl(null);
        break;
      default:
        alert("Please specify action item action");
        break;
    }
  };
  const actionPanel = (event, data, tableMeta) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(tableMeta);
  };
  return (
    <div
      className="table__linked-rows"
      style={{
        height: card.height - 45,
        overflowY: "auto",
        paddingLeft: "15px",
      }}
    >
      <List
        url={"getWorkflowList"}
        columns={WorkFlowListColumns(actionPanel, handleViewAction)}
        pagination={false}
        type={"workFlow_list"}
        sort={false}
        defaultSort={"fileNo"}
        defaultIndex={"fileNo"}
        defaultPageSize={4}
        reRender={reRender}
        // options={tableOptions}
      />
      <Loader open={loader} />
      <DropDownMenu
        anchorEl={anchorEl}
        onClose={handleClose}
        menuList={workFlowMenuList}
        handleMenuAction={handleMenuAction}
      />
    </div>
  );
}
